import {useState} from "react";
import TableList from "../../../component/TableList/TableList";
import SwitchJobActive from "./SwitchJobActive";
import TriggerJob from "./TriggerJob";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import HelpIcon from "@mui/icons-material/Help";
import {Button} from "@mui/material";
import JobInfoModal from "./JobInfoModal";

export default function JobManageList({
                                          baseUrl, loadData,
                                          setLoadData, size, page,
                                          setTotalPages, setTotalElements,
                                          sort, setSort, updateCode, setPage
                                      }) {

    const [data, setData] = useState([])
    const [error, setError] = useState(false)

    const [selectedItem, setSelectedItem] = useState(null);

    const handleOpenModal = (item) => setSelectedItem(item);
    const handleCloseModal = () => setSelectedItem(null);


    const titles = [
        'Id',
        'Nome',
        'Descrição',
        'Ativo'
    ]

    const tooltipMessages = {
        1: "Sincroniza os boletos entre o sistema e o BTG.",
        2: "Dispara alertas para boletos que vão vencer em breve.",
        3: "Desativa usuários inativos por 90 dias.",
        4: "Expira senhas de usuários que não trocaram em 1 ano.",
        5: "Atualiza o token usado na integração com o BTG.",
        6: "Marca como vencidos os boletos que passaram da data.",
        7: "Gera os pagamentos e realiza o split.",
        8: "Executa as transferências no BTG.",
        9: "Gera repasses financeiros para os parceiros.",
        10: "Envia alerta para boletos vencidos e não pagos.",
        11: "Atualiza o status dos pedidos baseado nas parcelas.",
        12: "Sincroniza os pagamentos entre BTG e o sistema.",
    };

    const renderItemTooltip = (message) => (props) => (
        <Tooltip id="tooltip-id" {...props}>
            {message}
        </Tooltip>
    );


    const readData = (resp) => {
        return resp.data
    }

    return (
        <>
            <TableList
                titles={titles} baseUrl={baseUrl + '/list'}
                page={page} sort={sort} size={size}
                loadData={loadData} readData={readData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={{}}
                error={error} setError={setError}
            >
                {data.map((item) =>
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.nome}</td>
                            <td>{item.descricao}</td>
                            <td>
                                <SwitchJobActive item={item} setLoadData={setLoadData} baseUrl={baseUrl}/>
                            </td>
                            <td>
                                <Button variant="link" onClick={() => handleOpenModal(item)}>
                                    <HelpIcon fontSize="small" />
                                </Button>
                            </td>

                            <td>
                                <TriggerJob item={item} setLoadData={setLoadData} baseUrl={baseUrl}/>
                            </td>
                        </tr>
                )}
            </TableList>
            {selectedItem && (
                <JobInfoModal
                    show={!!selectedItem}
                    handleClose={handleCloseModal}
                    item={selectedItem}
                />
            )}

        </>
    )
}